import { Box } from "@mui/material";
import { AccessibilityInfo } from "../accessibility/AccessibilityInfo";
import { FloatingInfo } from "../floating/FloatingInfo";
import { NotificationOpenButton } from "../notification/NotificationOpenButton";
import { NotificationListenerPanel } from "@src/components/notification-listener/NotificationListenerPanel";
export function HomePagePermissions(){
    return (<Box>
        <AccessibilityInfo />   
        <FloatingInfo />
        {/* <NotificationOpenButton /> */}
    </Box>)
}